import React from "react";
import BrandSplash from "./BrandSplash";

const FootballLoading = ({
  minDurationMs = 1200,
  message = "Cargando tu experiencia…",
  variant = "deportivospro",
  onDone,
}) => {
  return (
    <BrandSplash
      minDurationMs={minDurationMs}
      message={message}
      variant={variant}
      onDone={onDone}
    />
  );
};

export default FootballLoading;
